import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-event-reject',
  templateUrl: './event-reject.component.html',
  styleUrls: ['./event-reject.component.css'],
})
export class EventRejectComponent implements OnInit {
  reasonForm: FormGroup;
  datas;
  dataSource: MatTableDataSource<any>;
  private eventupdate = environment.url + environment.eventApproved;
  /**
   * Construct a new EventRejectComponent.
   *
   * @param data - The data that has been passed from the parent component.
   * @param fb - The form builder service.
   * @param makeapi - The API service.
   * @param getdata - The value service.
   * @param notify - The notification service.
   * @param dialogRef - The dialog reference.
   */
  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    public dialogRef: MatDialogRef<EventRejectComponent>
  ) {
    /**
     * The form group for the reason form.
     */
    this.reasonForm = this.fb.group({
      /**
       * The id of the event.
       */
      id: [''],
      /**
       * The status of the event.
       */
      status: [''],
      /**
       * The reason for rejecting the event.
       */
      reason: ['', [Validators.required]],
    });
    /**
     * The data that has been passed from the parent component.
     */
    this.datas = data;
    /**
     * Set the default values for the form.
     */
    let getform = this.reasonForm.value;
    getform.id = this.datas._id;
    getform.status = 2;
    this.reasonForm.patchValue(getform);
  }

  /**
   * The OnInit lifecycle hook.
   * Called when the component is initialized.
   * Sets the visibility of the component to true.
   */
  ngOnInit(): void {
    this.getdata.isVisibleSource.next(true);
  }
  get add() {
    return this.reasonForm.controls;
  }
  /**
   * Save the rejection reason to the API.
   * Constructs the request payload and sends it using the API service.
   * Closes the dialog and notifies success upon completion.
   */
  saveReason() {
    // Prepare the request payload
    let req = {
      id: this.datas._id, // Event ID
      status: 2, // Status indicating rejection
      remarks: this.reasonForm.value.reason, // Rejection reason
    };

    // Send the request to the API
    return this.makeapi
      .method(this.eventupdate, req, 'post')
      .subscribe((data) => {
        // Notify success with the response message
        this.notify.notifysuccess(data.responseMessage);

        // Close the dialog and reset the form
        this.cancelReason();
        this.dialogRef.close();
      });
  }
  /**
   * Cancels the rejection reason dialog.
   * Resets the form and closes the dialog.
   */
  cancelReason() {
    this.reasonForm.reset();
    this.dialogRef.close();
  }
}
